/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SharedMediaMetadataDto { 
    id?: number;
    author?: string;
    title?: string;
    state?: SharedMediaMetadataDto.StateEnum;
    tournamentId?: number;
}
export namespace SharedMediaMetadataDto {
    export type StateEnum = 'APPROVED' | 'REJECTED' | 'DELETED' | 'PENDING';
    export const StateEnum = {
        Approved: 'APPROVED' as StateEnum,
        Rejected: 'REJECTED' as StateEnum,
        Deleted: 'DELETED' as StateEnum,
        Pending: 'PENDING' as StateEnum
    };
}


